import { Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import "./v-radio-button.component.scss";

@Component({
    selector: 'v-radio-button',
    template: require('./v-radio-button.component.html')
})
export class VRadioButtonComponent {

    @Input() checkedValue: any;
    @Input() name:string = "default";
    @Input() option:string;
    @Input() title:string;
    @ViewChild('radiobutton') radioButton: ElementRef;

    @HostBinding("class.disabled") @Input() disabled: boolean;
    @Output() onChecked = new EventEmitter<any>();

    //get accessor
    get value(): any {
        return this.checkedValue;
    };

    onModelChange(value: any): void {
        this.emitValue();
    }

    triggerButtonClick (): void {
        this.radioButton.nativeElement.click();
    }

    private emitValue(): void {
        this.onChecked.emit(this.value);
    }
}
